import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {ProductManagementErrorInterface} from '../../../../../error/error-handling/product-management-error';
import {
  CREATE_PRODUCT_FEATURE_KEY,
  CreateProductState,
  getAddAnotherProduct,
  getCatalogs,
  getCatalogsLoading,
  getCreateProductRequest,
  getError,
  getLoading,
} from './create-product.reducer';

export const selectCreateProductFeature: MemoizedSelector<object, CreateProductState> =
  createFeatureSelector<CreateProductState>(CREATE_PRODUCT_FEATURE_KEY);

export const selectCreateProductLoading: MemoizedSelector<object, boolean> = createSelector(
  selectCreateProductFeature,
  getLoading
);

export const selectCreateProductCatalogs = createSelector(selectCreateProductFeature, getCatalogs);

export const selectCreateProductCatalogsLoading = createSelector(selectCreateProductFeature, getCatalogsLoading);

export const selectCreateProductError: MemoizedSelector<object, ProductManagementErrorInterface | undefined> =
  createSelector(selectCreateProductFeature, getError);

export const selectAddAnotherProduct: MemoizedSelector<object, boolean> = createSelector(
  selectCreateProductFeature,
  getAddAnotherProduct
);

export const selectCreateProductRequest = createSelector(selectCreateProductFeature, getCreateProductRequest);
